// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + ({"942":"not-found","966":"dashboard"}[chunkId] || chunkId) + "." + {"475":"b7307dbd","942":"dc260564","966":"0fa47c6c"}[chunkId] + ".chunk.js";
};